import React, { useState } from 'react';
import { X, Copy, Check, Code } from 'lucide-react';
interface ViewCodeModalProps {
  isOpen: boolean;
  onClose: () => void;
  html: string;
  title?: string;
}
export function ViewCodeModal({
  isOpen,
  onClose,
  html,
  title = 'Generated HTML'
}: ViewCodeModalProps) {
  const [copied, setCopied] = useState(false);
  if (!isOpen) return null;
  const handleCopy = () => {
    navigator.clipboard.writeText(html);
    setCopied(true);
    setTimeout(() => setCopied(false), 2000);
  };
  return <div className="fixed inset-0 z-50 flex items-center justify-center p-4 sm:p-6" data-id="element-2135" data-mp="3p1jv7nniy695">
      <div className="absolute inset-0 bg-gray-900/75 backdrop-blur-sm transition-opacity" onClick={onClose} data-id="element-2136" data-mp="3tsifeybmvoho" />
      <div className="relative bg-white rounded-xl shadow-2xl w-full max-w-4xl max-h-[90vh] flex flex-col overflow-hidden" data-id="element-2137" data-mp="2lfpsbbg1q9k">
        {/* Header */}
        <div className="flex items-center justify-between px-6 py-4 border-b border-gray-200" data-id="element-2138" data-mp="bnf6t3mgkuci">
          <div className="flex items-center gap-3" data-id="element-2139" data-mp="1o0gwbdbca8i5">
            <h2 className="text-lg font-semibold text-gray-900" data-id="element-2140" data-mp="1o18i5wf4wrv8">{title}</h2>
            <span className="px-2.5 py-0.5 rounded-full bg-gray-100 text-gray-600 text-xs font-medium" data-id="element-2141" data-mp="1jylt239ull1q">
              {html.length.toLocaleString()} chars
            </span>
          </div>
          <div className="flex items-center gap-2" data-id="element-2142" data-mp="1a17de5vr10ah">
            <button onClick={handleCopy} className="inline-flex items-center gap-1.5 px-3 py-1.5 text-sm font-medium text-gray-700 bg-white border border-gray-300 rounded-md hover:bg-gray-50 transition-colors" data-id="element-2143" data-mp="1a2ikofoekq6c">
              {copied ? <>
                  <Check className="h-4 w-4 text-green-600" data-id="element-2144" data-mp="1xwjw4cipxv1x" />
                  <span className="text-green-600" data-id="element-2145" data-mp="1syiezx4us5t3">Copied!</span>
                </> : <>
                  <Copy className="h-4 w-4" data-id="element-2146" data-mp="2qg8nlj3sd8ee" />
                  Copy
                </>}
            </button>
            <button onClick={onClose} className="p-1.5 text-gray-400 hover:text-gray-500 hover:bg-gray-100 rounded-md transition-colors" data-id="element-2147" data-mp="2lme7epne3bk2">
              <X className="h-5 w-5" data-id="element-2148" data-mp="nrh2yueisdp2" />
            </button>
          </div>
        </div>

        {/* Content */}
        <div className="flex-1 overflow-auto p-6 bg-gray-900" data-id="element-2149" data-mp="9yrhcr2wlash">
          {html ? <pre className="text-sm font-mono text-gray-300 whitespace-pre-wrap break-all" data-id="element-2150" data-mp="ey44ze1lmlw4">
              {html}
            </pre> : <div className="flex flex-col items-center justify-center h-full text-gray-500 space-y-2" data-id="element-2151" data-mp="52aip2y2ve15">
              <Code className="h-8 w-8 text-gray-600" data-id="element-2152" data-mp="3n7x82b162qir" />
              <p data-id="element-2153" data-mp="3n9gsmdtuvnqc">No HTML generated yet.</p>
              <p className="text-sm text-gray-600" data-id="element-2154" data-mp="3s5yvf85mlc01">
                Add blocks in the builder to generate code.
              </p>
            </div>}
        </div>
      </div>
    </div>;
}